import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { getDeepLink } from './getDeepLink';

export default function* watchDeepLink() {
    yield all([takeLatest(actionTypes.GET_DEEP_LINK_REQUEST, getDeepLink)]);
}
